var _this = this;
import * as tslib_1 from "tslib";
import { orchestrator } from 'satcheljs';
import { onSelectFolderComplete } from 'owa-mail-actions/lib/mailListActions';
import getSelectedFolder from 'owa-mail-store/lib/utils/getSelectedFolder';
import { getFolderByDistinguishedId } from 'owa-folders';
import setUnseenCount from '../mutators/setUnseenCount';
orchestrator(onSelectFolderComplete, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        if (getSelectedFolder() === getFolderByDistinguishedId('inbox')) {
            // clear the unseen count
            setUnseenCount(0);
        }
        return [2 /*return*/];
    });
}); });
//# sourceMappingURL=onFolderSelectedOrchestrator.js.map